import { useEffect, useState } from "react";

const useControlPress = () => {
  // State for keeping track of whether key is pressed
  const [keyPressed, setKeyPressed] = useState(false);
  // If pressed key is our target key then set to true
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const downHandler = ({ ctrlKey }) => {
    if (ctrlKey) {
      setKeyPressed(true);
    }
  };
  // If released key is our target key then set to false
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const upHandler = ({ ctrlKey }) => {
    if (!ctrlKey) {
      setKeyPressed(false);
    }
  };
  // Add event listeners
  useEffect(() => {
    window.addEventListener("keydown", downHandler);
    window.addEventListener("keyup", upHandler);
    // Remove event listeners on cleanup
    return () => {
      window.removeEventListener("keydown", downHandler);
      window.removeEventListener("keyup", upHandler);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return keyPressed;
};

export default useControlPress;
